import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'

import RichText, { RichTextBlock } from '~/components/UI/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type SectionTitleProps = {
  className?: string
  title: RichTextBlock
}

function SectionTitle({ className, title }: SectionTitleProps) {
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Title24SangBleuLight,
    color: GlobalThemeColors.Black,
  })

  return (
    <RichText
      className={cx(className, css.SectionTitle, titleStyle)}
      render={title}
    />
  )
}

SectionTitle.defaultProps = {}

export default SectionTitle
